import React, { useEffect, useRef, useState } from "react";

const stats = [
  { value: 10, suffix: "+", label: "Years of Industry Experience" },
  { value: 260, suffix: "+", label: "Quality Agricultural Products" },
  { value: 20, suffix: "+", label: "States Served Across India" },
  { value: 50000, suffix: "+", label: "Farmers Supported" }
];

const Counter = ({ value, suffix }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          let start = 0;
          const duration = 2000;
          const increment = value / (duration / 16);

          const counter = setInterval(() => {
            start += increment;
            if (start >= value) {
              setCount(value);
              clearInterval(counter);
            } else {
              setCount(Math.ceil(start));
            }
          }, 16);
        }
      },
      { threshold: 0.4 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [value]);

  return (
    <h2 ref={ref}>
      {count.toLocaleString()}
      {suffix}
    </h2>
  );
};

const StatsSection = () => {
  return (
    <section className="stats-section">
      <div className="container">
        <div className="row text-center">
          {stats.map((item, index) => (
            <div className="col-lg-3 col-md-6 mb-4" key={index}>
              <div className="stat-box">
                <Counter value={item.value} suffix={item.suffix} />
                <p>{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
